<script>
export default {
  props: ["ticket"],
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      timings: [],
      bank_info: [],
    };
  },
  watch: {},
  mounted() {
    console.log(this.ticket);
  },
  methods: {},
};
</script>

<template>
  <b-card>
    <b-card-header
      >Ticket: # {{ ticket.ticket_id }}
      <p>
        Priority : <b-badge variant="success">{{ ticket.priority }}</b-badge>
      </p></b-card-header
    >
    <b-card-body>
      <h4 v-if="ticket.category" style="text-transform: capitalize">
        Category : {{ ticket.category.split("_").join(" ") }}
      </h4>
      <h4
        v-if="ticket.extra_details.selected_type"
        style="text-transform: capitalize"
      >
        Type of Training : {{ ticket.extra_details.selected_type }}
      </h4>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th v-for="(t, ti) in ticket.extra_details.dates" :key="ti">
              {{ t.date }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="(t, ti) in ticket.extra_details.dates" :key="ti">
              <p v-for="(s, si) in t.slots" :key="si">{{ s }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card-body>
  </b-card>
</template>

<style></style>
